import React from "react";
import AddIntroductionTemplateModal from "features/Dealers/DealerDetails/AdditionalDocuments/AddIntroductionTemplateModal";
import {
  getIntroductionTemplates,
  approveAdditionalDocument,
  downloadAdditionalDocument,
} from "features/Dealers/DealerDetails/AdditionalDocuments/actions";
import AdditionalDocumentTable from "features/AdditionalDocuments/AdditionalDocumentTable";

const IntroductionTemplate = ({ dealerId }) => {
  return (
    <AdditionalDocumentTable
      dealerId={dealerId}
      loadAction={getIntroductionTemplates}
      emptyMessage="No Introduction Template"
      AddModal={AddIntroductionTemplateModal}
      approveAction={approveAdditionalDocument}
      downloadAction={downloadAdditionalDocument}
    />
  );
};

export default IntroductionTemplate;
